import React, { useState } from 'react';
import { toast } from 'sonner';
import { axiosInstance as axios } from '../../../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';

export function SaveTemplateModal({ eventId, defaultName, taskCount, onClose }) {
  const [name, setName] = useState(defaultName || '');
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.post(`/api/events/${eventId}/save-template`, { name });
      toast.success(`Saved "${name}" as a family template`);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to save template');
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent data-testid="save-template-modal">
        <DialogHeader>
          <DialogTitle>Save as a family template</DialogTitle>
          <DialogDescription>
            This event's {taskCount} tasks and their timing will be offered to everyone in your family when they create a new event. Who's assigned and what's done are not saved.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2" htmlFor="template-name">Template name</label>
            <input
              id="template-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={80}
              required
              placeholder="e.g. Rose Family Summer Reunion"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-600 focus:border-transparent"
              data-testid="template-name-input"
            />
          </div>
          <div className="flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-testid="cancel-save-template-btn">
              Cancel
            </button>
            <button type="submit" disabled={saving || !name.trim()} className="flex-1 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50" data-testid="submit-save-template-btn">
              {saving ? 'Saving...' : 'Save Template'}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
